React = require 'react'
t = require('views/internal/recup-with-helpers')('notification')
_ = require 'underscore'
$ = require 'jquery'

module.exports = class NotificationEmptyState extends React.Component
  displayName: 'NotificationEmptyState'

  constructor: (props) ->
    super(props)

    @state = {
      animate: false
      visible: props.visible
    }

  componentWillReceiveProps: (nextProps) ->
    if @state.visible != nextProps.visible
      @setState
        animate: true
        visible: nextProps.visible

  render: t.renderable ->
    { buttonClicked, isShowAll } = @props
    t.div
      class: t.classify({
        'notification-empty-state': true
        'animate': @state.animate
        'visible': @state.visible
        'hidden': !@state.visible
      })
    , =>
      t.img '.taco-sleep', { src: require('images/taco-sleep.svg') }
      t.div ->
        t.h3 '.quiet', ->
          if isShowAll
            t.format 'no-notifications'
          else
            t.format 'no-unread-notifications'
        t.h4 {
          class: t.classify({
            'quiet': true,
            'hidden': isShowAll
          }),
          onClick: buttonClicked
        }, ->
          t.format 'click-show-all-to-view-all',
            showAll: "<span class='view-all'>#{t.l 'view-all'}</span>"
          , { raw: true }



// WEBPACK FOOTER //
// ./app/scripts/views/notification/notification-empty-state.coffee